import mainRoutes from "./MainRoutes";

/**
 * meta: {
 *   requiresAuth: true  // 로그인 필요
 *   noCaching: true     // 캐싱 방지
 *   isDynamic: true     // 동적 라우트 (메뉴 권한 체크)
 *   menuCd: string      // 메뉴 코드
 *   title: string       // 국문 타이틀
 *   - 모바일 헤더 관련
 *   mobileTitle: string // 모바일 헤더 타이틀
 *   mobileHd: true      // 모바일 헤더 별도 적용
 *   likeBtn: true       // 모바일 헤더에 찜하기 버튼 노출
 *   homeBtn: true       // 모바일 헤더에 홈 버튼 노출
 *   gnbBtn: true        // 모바일 헤더에 메뉴 버튼 노출
 * }
 */

const clientRoutes = [
  {
    path: "",
    name: "index",
    redirect: { name: "clientMain" },
  },
  {
    path: "/",
    name: "client",
    meta: {
      title: "클라이언트",
      noCaching: true,
    },
    redirect: { name: "clientMain" },
    component: () => import("@/layout/LayoutMain.vue"),
    children: [...mainRoutes],
  },
];

export default clientRoutes;
